editEmailRequestForNotificationController.$inject = [
  '$scope',
  '$uibModalInstance',
  'companyId',
  'site',
  'content',
  'links',
  'emailSender',
  'emailSubject',
  'emailContent',
  'emailLinks',
  'landingPageUrl',
  'AlertingFactory',
  'QuickRepliesFactory',
];
export function editEmailRequestForNotificationController(
  $scope,
  $uibModalInstance,
  companyId,
  site,
  content,
  links,
  emailSender,
  emailSubject,
  emailContent,
  emailLinks,
  landingPageUrl,
  AlertingFactory,
  QuickRepliesFactory
) {
  $scope.submit = submit;
  $scope.cancel = cancel;
  $scope.initialQuestionModel = {
    text: content,
    links: links,
  };
  $scope.questionModelAccessor = {};
  $scope.questionTextIsEmpty = false;
  $scope.emailTextIsEmpty = false;
  $scope.companyId = companyId;
  $scope.site = site;
  $scope.initialEmailModel = {
    text: emailContent,
    links: emailLinks,
  };
  $scope.email = {
    sender: emailSender,
    subject: emailSubject,
  };
  $scope.emailModelAccessor = {};
  $scope.landingPageUrl = landingPageUrl;

  init();

  function init() {
    QuickRepliesFactory.getInMessageCustomization(companyId, site.id)
      .then(response => {
        if (!$scope.email.sender) {
          $scope.email.sender = response.data.defaultSenderName;
          $scope.email.subject = response.data.defaultObject;
        }
      }, AlertingFactory.httpErrorHandler())
      .finally(() => {});
  }

  function submit() {
    let questionModel = $scope.questionModelAccessor.getModelOfFirstMessage();
    let emailModel = $scope.emailModelAccessor.getModelOfFirstMessage();
    $uibModalInstance.close({
      type: 'edit',
      data: {
        content: questionModel['text'],
        links: questionModel['links'],
        emailSender: $scope.email.sender,
        emailSubject: $scope.email.subject,
        emailContent: emailModel['text'],
        emailLinks: emailModel['links'],
        landingPageUrl: $scope.landingPageUrl,
      },
    });
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }
}
